import { render } from "./WCMobileSideBar.vue?vue&type=template&id=db3dd53e&scoped=true"
import script from "./WCMobileSideBar.vue?vue&type=script&lang=js"
export * from "./WCMobileSideBar.vue?vue&type=script&lang=js"

import "./WCMobileSideBar.vue?vue&type=style&index=0&id=db3dd53e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db3dd53e"]])

export default __exports__